/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { COMPONENT_OUTPUT_TYPE_HTML } from '../../ComponentOutput.entity.constant';
import { ComponentHtmlOutputStaticFile } from '../ComponentHtmlOutputStaticFile/ComponentHtmlOutputStaticFile.entity';

/**
 * The dxp component html output entity type.
 * @export
 */
export type EntityComponentHtmlOutput = io.TypeOf<typeof ComponentHtmlOutput>;

/**
 * The dxp component html output entity definition.
 * @export
 */
export const ComponentHtmlOutput = io.intersection(
  [
    io.type({
      responseType: io.literal(COMPONENT_OUTPUT_TYPE_HTML),
    }),
    io.partial({
      staticFiles: io.array(ComponentHtmlOutputStaticFile),
    }),
  ],
  `ComponentHtmlOutput`,
);
